module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/underhead/underhead.component.scss
// module id = ./src/app/underhead/underhead.component.scss
// module chunks = main